export interface TaxInfo {
    taxId?: string;
    taxStatus?: TaxStatus;
}

export enum TaxStatus {
    Taxable = 'taxable',
    Exempt = 'exempt'
}



// WEBPACK FOOTER //
// ./src/webportal/components/billing/details/interfaces/TaxInfo.ts